import React from 'react'

import Nodes_ from './nodes_pri_wht_rgb.svg'
import Ascon_ from './ascon_pri_wht_rgb.svg'
import Ava_ from './ava_white_rgb.svg'
import Bleenco_ from './bleenco_white_rgb.svg'
import Breezometer_ from './breezometer_pri_wht_rgb.svg'
import Circularise_ from './circularise_pri_wht_rgb.svg'
import Circulartree_ from './circulartree_pri_wht_rgb.svg'
import Climacell_ from './climacell_pri_wht_rgb.svg'
import Datenberg_ from './datenberg_pri_wht_rgb.svg'
import Forciot_ from './forciot_pri_wht_rgb.svg'
import Foretellix_ from './foretellix_pri_wht_rgb.svg'
import Hiauto_ from './hiauto_pri_wht_rgb.svg'
import Hydrogenious_ from './hydrogenious_pri_wht_rgb.svg'
import Imagine_ from './imagine_pri_wht_rgb.svg'
import Inspekto_ from './inspekto_pri_wht_rgb.svg'
import Monk_ from './monk_pri_wht_rgb.svg'
import Nexmachina_ from './nexmachina_pri_wht_rgb.svg'
import Noiseless_ from './noiseless_acoustics_pri_wht_rgb.svg'
import Oculavis_ from './oculavis_pri_wht_rgb.svg'
import Ontology_ from './ontology_pri_wht_rgb.svg'
import Riddleandcode_ from './riddleandcode_pri_wht_rgb.svg'
import Senseforce_ from './senseforce_pri_wht_rgb.svg'
import Silexica_ from './silexica_pri_wht_rgb.svg'
import Spherity_ from './spherity_pri_wht_rgb.svg'
import Synthesia_ from './synthesia_sec_wht_rgb.svg'
import Ubq_ from './ubq_pri_wht_rgb.svg'
import Vispa_ from './vispa_pri_wht_rgb.svg'
import Voixen_ from './voixen_pri_wht_rgb.svg'
import Wem_ from './wem_pri_wht_rgb.svg'
import Wiferion_ from './wiferion_pri_wht_rgb.svg'
import Zensors_ from './zensors_pri_wht_rgb.svg'

export const Nodes = () => { return (<Nodes_ />) }; 
export const Ascon = () => { return (<Ascon_ />) }; 
export const Ava = () => { return (<Ava_ />) }; 
export const Bleenco = () => { return (<Bleenco_ />) }; 
export const Breezometer = () => { return (<Breezometer_ />) }; 
export const Circularise = () => { return (<Circularise_ />) }; 
export const Circulartree = () => { return (<Circulartree_ />) }; 
export const Climacell = () => { return (<Climacell_ />) }; 
export const Datenberg = () => { return (<Datenberg_ />) }; 
export const Forciot = () => { return (<Forciot_ />) }; 
export const Foretellix = () => { return (<Foretellix_ />) }; 
export const Hiauto = () => { return (<Hiauto_ />) }; 
export const Hydrogenious = () => { return (<Hydrogenious_ />) }; 
export const Imagine = () => { return (<Imagine_ />) }; 
export const Inspekto = () => { return (<Inspekto_ />) }; 
export const Monk = () => { return (<Monk_ />) }; 
export const Nexmachina = () => { return (<Nexmachina_ />) }; 
export const Noiseless = () => { return (<Noiseless_ />) }; 
export const Oculavis = () => { return (<Oculavis_ />) }; 
export const Ontology = () => { return (<Ontology_ />) }; 
export const Riddleandcode = () => { return (<Riddleandcode_ />) }; 
export const Senseforce = () => { return (<Senseforce_ />) }; 
export const Silexica = () => { return (<Silexica_ />) }; 
export const Spherity = () => { return (<Spherity_ />) }; 
export const Synthesia = () => { return (<Synthesia_ />) }; 
export const Ubq = () => { return (<Ubq_ />) }; 
export const Vispa = () => { return (<Vispa_ />) }; 
export const Voixen = () => { return (<Voixen_ />) }; 
export const Wem = () => { return (<Wem_ />) }; 
export const Wiferion = () => { return (<Wiferion_ />) }; 
export const Zensors = () => { return (<Zensors_ />) }; 